(function () {
  'use strict';

  window.__vspData = window.__vspData || {
    chevrolet: ['Aveo Emotion', 'Aveo Family', 'Aveo GT', 'Beat', 'Cobalt', 'Corsa', 'DMax', 'Joy', 'N300', 'N400', 'Onix', 'Optra', 'Sail', 'Sonic', 'Spark', 'Spark GT', 'Swift', 'Tracker'],
    citroen:   ['C3', 'C4'],
    fiat:      ['500', 'Moby', 'Pulse', 'Topolino', 'Uno Way'],
    ford:      ['Eco Sport', 'Fiesta'],
    honda:     ['City LX', 'CRV', 'Fit 2008-13', 'Fit 2015-20'],
    hyundai:   ['Atos', 'Getz', 'Grand I10', 'HB20', 'i25', 'i30', 'Accent'],
    jac:       ['J2', 'S2'],
    kia:       ['Cerato', 'K3', 'Picanto Ion', 'Picanto Morning', 'Picanto New', 'Picanto R', 'Picanto Vibrant', 'Picanto Zenith', 'Rio New', 'Rio Soluto', 'Rio Spice', 'Rio Stylus', 'Rio Vibrant', 'Rio Xcite', 'Rio Zenith', 'Soul 2012', 'Soul 2013-2019'],
    mazda:     ['626', 'CX3', 'Mazda 2 cara nueva', 'Mazda 2 hasta 2015'],
    mitsubishi: ['Montero'],
    nissan:    ['Frontier', 'Juke', 'Kicks', 'March', 'Note', 'Tiida', 'Versa'],
    peugeot:   ['206', '208', '2008'],
    renault:   ['9', 'Captur', 'Clio', 'Duster 2012-2021', 'Duster 2022-2025', 'Kangoo', 'Kardian', 'Kwid', 'Logan 2010-2012', 'Logan 2013-2025', 'Megane', 'Oroch', 'Sandero', 'Stepway', 'Twingo'],
    suzuki:    ['Alto', 'Baleno', 'Dzire', 'Ertiga', 'Spresso', 'Jimny New', 'Jimny Old', 'Swift', 'Swift 3 puertas', 'Swift Híbrido', 'SX4', 'Vitara Live', 'Vitara 3 puertas'],
    toyota:    ['Hilux'],
    volkswagen: ['Gol', 'Jetta', 'Parati', 'Polo Track', 'TCross', 'Tera', 'Virtus', 'Voyage']
  };

  var HELP_TEXT    = 'Elige tu vehículo para continuar con la compra';
  var vehicleReady = false;
  var selectedBrand = '';
  var selectedModel = '';

  // Lock/unlock the RSI "REALIZAR PEDIDO" button via body class.
  // Avoids touching the native Dawn button (which RSI monitors for product availability).
  function lockUI()   { document.body.classList.add('vsp-locked'); }
  function unlockUI() { document.body.classList.remove('vsp-locked'); }

  function showHelp(el) {
    el.className   = 'vsp-feedback';
    el.style.color = '#999';
    el.textContent = HELP_TEXT;
  }

  // Writes/updates the "Vehículo" line item property on a cart form so the
  // selected brand+model travels with the order instead of staying purely
  // visual. Safe to call repeatedly (updates the existing input in place).
  function setVehicleProperty(form) {
    if (!form || !selectedBrand || !selectedModel) return;

    var value    = selectedBrand + ' ' + selectedModel;
    var existing = form.querySelector('input[name="properties[Vehículo]"]');

    if (existing) {
      existing.value = value;
    } else {
      var input = document.createElement('input');
      input.type  = 'hidden';
      input.name  = 'properties[Vehículo]';
      input.value = value;
      form.appendChild(input);
    }
  }

  // Dawn renders a second, duplicate /cart/add form for the sticky buy box
  // (enable_sticky_info) — whichever form actually contains the button the
  // shopper clicked is the one that submits, so every matching form on the
  // page needs the property, not just the first one found.
  function syncAllCartForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(setVehicleProperty);
  }

  // Picks the best matching <option> in an RSI vehicle <select> for the
  // brand+model chosen in our own selector. RSI's own list is a fixed,
  // coarser catalog (e.g. "Kia Picanto" with no "Morning"/"Ion"/"New"
  // trim), so an exact "brand model" string essentially never exists —
  // this falls back progressively: exact match, then brand + first word
  // of the model (covers the common "Familia Trim" naming in our list),
  // then brand alone.
  function pickRsiOption(select, brand, model) {
    var options = Array.prototype.filter.call(select.options, function (o) {
      return o.value;
    });
    if (!options.length) return null;

    var brandLower = brand.toLowerCase();
    var modelFirstWord = model.split(' ')[0].toLowerCase();
    var target = (brand + ' ' + model).toLowerCase();

    var exact = options.filter(function (o) {
      return o.text.toLowerCase() === target;
    })[0];
    if (exact) return exact;

    var partial = options.filter(function (o) {
      var t = o.text.toLowerCase();
      return t.indexOf(brandLower) === 0 && t.indexOf(modelFirstWord) !== -1;
    })[0];
    if (partial) return partial;

    var brandOnly = options.filter(function (o) {
      return o.text.toLowerCase().indexOf(brandLower) === 0;
    })[0];
    return brandOnly || null;
  }

  // Prefills RSI's own "MODELO DE TU VEHÍCULO" field in the checkout
  // modal so the value our selector already confirmed doesn't have to be
  // re-entered by the shopper — and so it actually ends up on the order,
  // since RSI's own add-to-cart call doesn't read the properties we set
  // on the native form (see setVehicleProperty/syncAllCartForms above).
  function syncRSIField() {
    if (!selectedBrand || !selectedModel) return;

    function fillField() {
      var filled = false;

      // Free-text inputs, in case a different RSI field configuration ever
      // uses one instead of a dropdown. Deliberately scoped to inputs whose
      // OWN name/placeholder names the vehicle — NOT "any text input inside
      // an rsi-classed container", which also matches name/address/city in
      // RSI's own shipping form and corrupts them (caught during live
      // verification: first_name/address/city all got overwritten).
      var textSelectors = [
        'input[name*="vehicle"]',
        'input[name*="vehiculo"]',
        'input[name*="modelo"]',
        'input[placeholder*="vehículo"]',
        'input[placeholder*="vehiculo"]',
        'input[placeholder*="modelo"]'
      ];
      var vehicleText = selectedBrand + ' ' + selectedModel;
      textSelectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (field) {
          field.value = vehicleText;
          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          filled = true;
        });
      });

      // The actual RSI field on this store: a <select> named
      // "additionals_dropdown_input_MODELO DE TU VEHÍCULO" with a fixed
      // catalog of options, not a free-text input.
      var selectSelectors = [
        'select[name^="additionals_dropdown_input"]',
        'select[id^="_rsi-field-"]',
        'select[placeholder*="VEHÍCULO"]',
        'select[placeholder*="VEHICULO"]'
      ];
      var selects = document.querySelectorAll(selectSelectors.join(','));
      selects.forEach(function (select) {
        var option = pickRsiOption(select, selectedBrand, selectedModel);
        if (!option) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        filled = true;
      });

      return filled;
    }

    if (!fillField()) {
      // The modal (and its field) may not exist yet if this runs before
      // "REALIZAR PEDIDO" is clicked — watch for it to appear.
      var observer = new MutationObserver(function () {
        if (fillField()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  }

  // Intercepts clicks on the RSI buy-now button and the native Dawn
  // add-to-cart/buy-buttons before their own click handlers run (capture
  // phase on document fires before any listener bound on the button
  // itself), so the hidden property input is already in the DOM by the
  // time those handlers read the form.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      '[id*="rsi"],[class*="rsi"],.product-form__submit,button[name="add"]'
    );
    if (!btn) return;
    if (!selectedBrand || !selectedModel) return;

    // Prioritize the form the clicked button actually belongs to (Dawn's
    // sticky buy box duplicates the whole form), then sync every other
    // matching form on the page as a fallback.
    var ownForm = btn.closest('form[action*="/cart/add"]');
    if (ownForm) setVehicleProperty(ownForm);
    syncAllCartForms();

    // The click that opens RSI's modal is also the moment its field gets
    // created — (re)arm the fill/observe logic right here too, in case
    // the one triggered on model-change already timed out.
    syncRSIField();
  }, true);

  // RSI's own checkout form (if it uses one) is injected into the DOM
  // dynamically after "REALIZAR PEDIDO" is clicked — it doesn't exist at
  // page load, so a one-time querySelectorAll would find nothing. Observe
  // the body for new rsi forms and bind a submit listener to each as they
  // appear, same pattern already used elsewhere in this theme for RSI.
  function bindRsiForm(form) {
    if (form.__vspBound) return;
    form.__vspBound = true;
    form.addEventListener('submit', function () {
      setVehicleProperty(form);
    }, true);
  }

  function scanForRsiForms(root) {
    var forms = root.querySelectorAll
      ? root.querySelectorAll('form[id*="rsi"],form[class*="rsi"]')
      : [];
    forms.forEach(bindRsiForm);
    if (root.matches && root.matches('form[id*="rsi"],form[class*="rsi"]')) {
      bindRsiForm(root);
    }
  }

  var rsiFormObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scanForRsiForms(node);
      });
    });
  });

  function init() {
    var brand    = document.getElementById('vsp-brand');
    var model    = document.getElementById('vsp-model');
    var feedback = document.getElementById('vsp-feedback');

    if (!brand || !model || !feedback) return;

    lockUI();
    showHelp(feedback);

    brand.addEventListener('change', function () {
      model.innerHTML = '<option value="">Modelo</option>';
      model.disabled  = true;
      vehicleReady    = false;
      selectedBrand   = '';
      selectedModel   = '';
      showHelp(feedback);
      lockUI();

      if (!this.value) return;

      var models = (window.__vspData || {})[this.value] || [];
      models.forEach(function (m) {
        var opt = document.createElement('option');
        opt.value = m;
        opt.textContent = m;
        model.appendChild(opt);
      });
      model.disabled = false;
    });

    model.addEventListener('change', function () {
      if (!brand.value || !this.value) {
        vehicleReady  = false;
        selectedModel = '';
        showHelp(feedback);
        lockUI();
        return;
      }

      vehicleReady  = true;
      selectedBrand = brand.options[brand.selectedIndex].text;
      selectedModel = this.value;
      unlockUI();

      // Keep every cart form on the page in sync immediately too, in case
      // a buy button click fires before this handler runs again.
      syncAllCartForms();

      // Prefill RSI's own vehicle field so the checkout modal already
      // shows the closest match instead of asking the shopper again.
      syncRSIField();

      var brandName = selectedBrand;
      var modelName = selectedModel;

      feedback.className   = 'vsp-feedback vsp-feedback--ok';
      feedback.style.color = '';
      feedback.innerHTML   = '✓ ' + brandName + ' ' + modelName;
    });
  }

  function start() {
    init();
    scanForRsiForms(document.body);
    rsiFormObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function(){
  function hidePlaceholderVariant(){
    var selects = document.querySelectorAll(
      'select.product-form__input, select[name="id"]'
    );
    selects.forEach(function(sel){
      Array.from(sel.options).forEach(function(opt){
        if(opt.text.toLowerCase().includes('elige') ||
           opt.text.toLowerCase().includes('escríbenos')){
          opt.disabled = true;
          opt.style.display = 'none';
        }
      });
      // Si el valor actual es el placeholder,
      // seleccionar la primera opción real
      if(sel.selectedOptions[0] &&
         (sel.selectedOptions[0].text.toLowerCase()
          .includes('elige') ||
          sel.selectedOptions[0].text.toLowerCase()
          .includes('escríbenos'))){
        // Seleccionar primera opción no-placeholder
        Array.from(sel.options).some(function(opt){
          if(!opt.disabled){
            sel.value = opt.value;
            sel.dispatchEvent(
              new Event('change',{bubbles:true})
            );
            return true;
          }
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded',
    hidePlaceholderVariant);
  setTimeout(hidePlaceholderVariant, 500);
})();
